import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Drawer } from 'antd';
import appRoutes from 'config/appRoutes';
import ProfileContact from 'modules/contact/views/profile';

interface ProfileModalProps {
  uuid: string | null;
  onClose: () => void;
}

const ProfileModal: FC<ProfileModalProps> = ({ uuid, onClose }) => {
  const history = useHistory();
  const isOpen = !!uuid;

  const handleEdit = () => {
    history.push(`${appRoutes.CONTACTS}/${uuid}/edit`);
    onClose();
  };

  return (
    <Drawer visible={isOpen} maskClosable maskStyle={{ background: 'transparent' }} width={640} footer={null} onClose={onClose}>
      {isOpen && <ProfileContact reduced uuid={uuid ?? undefined} onEdit={handleEdit} />}
    </Drawer>
  );
};

export default ProfileModal;
